module.exports = __webpack_public_path__ + "img/homeImg.4bc794fa.png";